import styled, { css, keyframes } from 'styled-components'
import { colors, device } from '../../../styles/GlobalVariables'

const loader = keyframes`
    0% {
        background-color: black;
    }
    100% {
        background-color: ${colors.tvGuideDark};
    }
`
export const EpisodeListItemWrap = styled.div`
  display: flex;
  cursor: pointer;
  margin-bottom: 0;
  width: 100%;

  ${device.medium} {
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }

  flex-direction: row;

  a {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    width: 100%;

    ${device.medium} {
      flex-direction: column;
    }

    ${device.small} {
      gap: 1rem;
    }

    @media only screen and (max-width: 768px) {
      gap: 0.7rem;
    }
  }
`
const EpisodeListItemThumbnailWidth = '44.3vw'
export const EpisodeListItemThumbnail = styled.div`
  height: 0;
  width: ${EpisodeListItemThumbnailWidth};
  min-width: ${EpisodeListItemThumbnailWidth};
  padding-bottom: calc(${EpisodeListItemThumbnailWidth} * 9 / 16);
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  transition: all 0.25s ease-in;
  transform-origin: center;
  display: inline-flex;

  img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${device.small} {
    width: 240px;
    min-width: 240px;
    padding-bottom: calc(240px * 9 / 16);
    border-radius: 10px;

    &:after {
      content: '';
      transition: opacity 0.25s ease-in;
      opacity: 0;
      position: absolute;
      bottom: 0.625rem;
      right: 0.625rem;
      width: 1.25rem;
      height: 1.25rem;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg fill='white' version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2rem' height='2rem' viewBox='0 0 163.861 163.861' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275 c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z'/%3E%3C/g%3E%3C/svg%3E");
      z-index: 1;
    }

    &:hover {
      transform: scale(1.05);

      &:after {
        opacity: 1;
      }
    }
  }

  ${props =>
    props.theme.useDefault
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 45%;
          }
        `
      : ''}

  ${props =>
    props.theme.loaded
      ? ''
      : css`
          animation: ${loader} 1s linear infinite;
        `}
    ${props =>
    props.theme.error
      ? css`
          background: linear-gradient(
            90deg,
            #06060d -34.07%,
            #171f3d 47.01%,
            #06060d 137.67%
          );

          img {
            width: 45%;
          }
        `
      : ''};
`

export const EpisodeListItemDetailsWrap = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 100%;
  height: auto;
  text-decoration: none;
  color: white;
  gap: 4px;

  ${device.small} {
    gap: 4px;
  }
`

export const EpisodeListItemTitle = styled.div`
  text-decoration: none;
  ${device.medium} {
    color: #fff;
    text-align: right;
    font-size: 23px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.46px;
    width: 300px;
    position: relative;
  }

  color: #fff;
  text-align: right;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.44px;
  width: 160px;

  @media only screen and (max-width: 768px) {
    font-size: 18px;
  }
`
export const EpisodeListItemDescription = styled.div`
  ${device.medium} {
    color: rgba(255, 255, 255, 0.7);
    font-size: 20px;
    font-style: normal;
    font-weight: 300;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: 5rem;
    letter-spacing: -0.4px;
    max-width: 92%;
  }

  max-width: 100%;
  display: none;
`
export const EpisodeListItemDate = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  font-weight: 100;
  letter-spacing: -0.48px;

  @media only screen and (max-width: 768px) {
    font-size: 18px;
    margin-top: 0.375rem;
  }
`
